'use client'

import {
  DarkFandomLogoLoop,
  DarkFandomLogoLoopReversed
} from '@/components/styled/DarkFandomLogoLoop'
import {
  FandomLogoLoop,
  FandomLogoLoopReversed
} from '@/components/styled/FandomLogoLoop'
import { useTranslation } from 'react-i18next'

const FandomLogoSection = () => {
  const { t } = useTranslation('home')

  return (
    <>
      <section className="flex flex-col overflow-hidden sm:gap-14">
        <div className="dark:hidden">
          <FandomLogoLoop />
          <FandomLogoLoopReversed />
        </div>
        <div className="hidden dark:block">
          <DarkFandomLogoLoop />
          <DarkFandomLogoLoopReversed />
        </div>
        <p className="mb-9 mt-10 text-center text-[12px] text-sub-light-1 sm:hidden dark:text-sub-dark-1">
          {t('fandom_message')}
        </p>
      </section>
    </>
  )
}

export default FandomLogoSection
